import { render, staticRenderFns } from "./penaltyDetails.vue?vue&type=template&id=1387a972&scoped=true"
import script from "./penaltyDetails.vue?vue&type=script&lang=js"
export * from "./penaltyDetails.vue?vue&type=script&lang=js"
import style0 from "./penaltyDetails.vue?vue&type=style&index=0&id=1387a972&prod&lang=scss&scoped=true"
import style1 from "./penaltyDetails.vue?vue&type=style&index=1&id=1387a972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1387a972",
  null
  
)

export default component.exports